import { AbstractModel } from '../abstract.model';
import { Geometry } from 'geojson';

export class IFlag extends AbstractModel {
  targetObjectId: string;
  targetObjectType: 'mapObject' | 'notification' | 'diary' | 'flag';
  global: boolean;
  userId: string;
  groupId?: string;
  layerId?: string;
  geometry?: Geometry;

  constructor() {
    super();
    this.id = null;
  }
}
